export default {
  title: 'Select Scan Template',
  empty: 'No template data',
  searchPlaceholder: 'Search by template name',
};
